import api from '@/utils/api'
import { buildListQuery } from '@/utils/listQuery'

export default {
    getFaqs(page, size) {
        let range = '?range=' + encodeURIComponent(`[${page - 1},${size}]`)
        return api.get(`faqs` + (page ? range : ''))
    },

    getFilteredFaqs(filter, page, size, sort) {
        return api.get(`faqs` + buildListQuery({ filter, page, size, sort }))
    },

    getFaq(id) {
        return api.get(`faqs/${id}`)
    },

    createFaq(data) {
        return api.post('faqs', data)
    },

    updateFaq(id, data) {
        return api.put(`faqs/${id}`, data)
    },

    deleteFaq(id) {
        return api.delete(`faqs/${id}`)
    }
}
